import {useMemo} from 'react';
import {useFeaturedReportsQuery} from '../state/graphql/reportAdminBar';
import {ExtraStuffSection, FeaturedReport, GalleryTagSection} from './gallery';

export interface FeaturedReportsSpec {
  reports: FeaturedReport[];
  tagSections: GalleryTagSection[];
  extraStuffSections: ExtraStuffSection[];
  topLevelFeaturedReportIDs: string[];
}

export const emptyReportData: FeaturedReportsSpec = {
  reports: [],
  tagSections: [],
  extraStuffSections: [],
  topLevelFeaturedReportIDs: [],
};

export function useFeaturedReports(): {
  loading: boolean;
  viewID: string | null;
} & FeaturedReportsSpec {
  const featuredReportsResult = useFeaturedReportsQuery({});

  const viewID = !featuredReportsResult.loading
    ? featuredReportsResult.featuredReports?.id
    : null;
  const featuredReportsSpec = !featuredReportsResult.loading
    ? featuredReportsResult.featuredReports?.spec
    : null;

  const featuredReports: FeaturedReportsSpec = useMemo(
    () =>
      featuredReportsSpec != null
        ? JSON.parse(featuredReportsSpec)
        : emptyReportData,
    [featuredReportsSpec]
  );

  return {
    loading: featuredReportsResult.loading,
    viewID: viewID ?? null,
    ...featuredReports,
  };
}

export function useIsFeaturedReport(): {
  loading: boolean;
  isFeaturedReport: boolean;
} {
  const {loading, reports: featuredReports} = useFeaturedReports();

  const isFeaturedReport = featuredReports.some(
    r => r.link === window.location.pathname
  );

  return {loading, isFeaturedReport};
}
